// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"25a40fbb","475":"4acfbe79","695":"c617b394"}[chunkId] + ".chunk.css";
};